// Entry point for the build script in your package.json
import ujs from "@rails/ujs";
ujs.start();
